<template>
	<div @keydown.esc="closeModal" class="modal-video">
		<transition name="modal-fade" @enter="transitionEnter">
			<div
				v-show="isModalVisible"
				class="modal-mask"
				:aria-hidden="!isModalVisible"
				@click="closeModal"
				@keydown.esc="closeModal"
			>
				<div class="modal__wrapper">
					<div
						ref="modalContainer"
						class="modal"
						role="dialog"
						aria-labelledby="modalTitle"
						tabindex="-1"
						@click.stop
					>
						<video-youtube-player
							ref="player"
							:video-id="videoId"
							:is-playlist="isPlaylist"
							:poster-hide="true"
							@close="closeModal"
						/>
					</div>
					<close-button
						color="-black"
						:event="closeModal"
						svg-icon=""
					></close-button>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import { nextTick } from 'vue';
import CloseButton from '../CloseButton';
import VideoYoutubePlayer from '../VideoYoutubePlayer';
import { EventBus } from '../../utils/EventBus';

export default {
	name: 'ModalVideo',
	components: {
		CloseButton,
		VideoYoutubePlayer,
	},
	props: {
		modalId: { type: String, required: false, default: null },
		videoId: { type: String, required: true },
		isPlaylist: { type: Boolean, required: false, default: false },
	},
	data() {
		return {
			isModalVisible: false,
			initialFocus: null,
			backups: {
				body: {
					height: null,
					overflow: null,
				},
			},
		};
	},
	created() {
		EventBus.$on('open-modal', this.handleOpenModal);
	},
	methods: {
		handleOpenModal(eventModalId) {
			if (this.modalId === eventModalId) {
				this.showModal();
			}
		},
		showModal() {
			this.isModalVisible = true;
			this.initialFocus = document.activeElement;
			this.fixBody();
			this.setModalFocus();

			nextTick(() => {
				this.$refs.player.clickThumbnail();
			});
		},
		transitionEnter() {
			EventBus.$emit('open-modal-transition');
		},
		closeModal(event) {
			if (event) event.stopPropagation();
			this.$refs.player.stopVideo();

			nextTick(() => {
				this.isModalVisible = false;
				this.freeBody();
				this.restoreModalFocus();
				EventBus.$emit('close-modal', this.modalId);
			});
		},
		fixBody() {
			this.backups.body.height = document.body.style.height;
			this.backups.body.overflow = document.body.style.overflow;
			document.body.style.height = '100%';
			document.body.style.overflow = 'hidden';
		},
		freeBody() {
			document.body.style.height = this.backups.body.height;
			document.body.style.overflow = this.backups.body.overflow;
		},
		setModalFocus() {
			// had to use next tick, otherwise some other code would grab the focus
			nextTick(() => {
				this.$refs.modalContainer.focus();
			});
		},
		restoreModalFocus() {
			this.initialFocus.focus();
		},
	},
};
</script>

<style lang="scss">
.close-btn {
	cursor: pointer;
}
</style>
